const Backbone = require('backbone');

module.exports = Backbone.View.extend({
	initialize: function() {
		this.$elemQuantity = this.$el.find('.js-quantity');
		this.$elemGallons = this.$el.find('.js-gallons');
	},
	updateQuantity: function(quantity) {
		const numberQuantity = Number(quantity);
		if (numberQuantity || numberQuantity === 0) {
			this.$elemQuantity.html(Math.max(numberQuantity, 0));
			this.$elemGallons.html(numberQuantity === 1 ? 'Gallon' : 'Gallons');
		}
	}
});
